import { render } from "./ElectronicClassCard.vue?vue&type=template&id=74025e12&scoped=true"
import script from "./ElectronicClassCard.vue?vue&type=script&lang=js"
export * from "./ElectronicClassCard.vue?vue&type=script&lang=js"

import "./ElectronicClassCard.vue?vue&type=style&index=0&id=74025e12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74025e12"]])

export default __exports__